import React, { useState } from 'react';
import { CapturePropertyRobotDTO } from 'business/models/Models';
import FRAPBleaching from './FRAPBleaching';
import FRAPImaging from './FRAPImaging';
import FRAPGeneral from './FRAPGeneral';
import FRAPPostBleach from './FRAPPostBleach';
import { FrapConfigType } from '../../types';

interface FRAPCustomControlsProps {
  opticsFields: string[];
  robotCaptureProperties: CapturePropertyRobotDTO;
  robotConfig: string;
  lightPath: string;
  selectedCp: number[];
  robotId: number;
  handleChange: (propertyName: string, value: any) => void;
  handleFieldToggle: (propertyName: string, value?: any) => void;
  enabledFields: string[];
  frapConfig: FrapConfigType;
}

function FRAPCustomControls(props: FRAPCustomControlsProps) {
  const {
    robotCaptureProperties,
    robotId,
    lightPath,
    handleChange,
    handleFieldToggle,
    enabledFields,
    frapConfig,
  } = props;

  const [tab, setTab] = useState<number>(1);

  const FRAPConfigTabs = [
    {
      id: 1,
      title: 'Bleaching',
      component: (
        <FRAPBleaching
          robotCaptureProperties={robotCaptureProperties}
          robotId={robotId}
          handleChange={handleChange}
          handleFieldToggle={handleFieldToggle}
          enabledFields={enabledFields}
          lightPath={lightPath}
          frapConfig={frapConfig}
        />
      ),
    },
    {
      id: 2,
      title: 'Post-Bleach',
      component: (
        <FRAPPostBleach
          robotCaptureProperties={robotCaptureProperties}
          robotId={robotId}
          handleChange={handleChange}
          handleFieldToggle={handleFieldToggle}
          enabledFields={enabledFields}
          lightPath={lightPath}
          frapConfig={frapConfig}
        />
      ),
    },
    {
      id: 3,
      title: 'Imaging',
      component: (
        <FRAPImaging
          robotCaptureProperties={robotCaptureProperties}
          robotId={robotId}
          handleChange={handleChange}
          handleFieldToggle={handleFieldToggle}
          enabledFields={enabledFields}
          lightPath={lightPath}
          frapConfig={frapConfig}
        />
      ),
    },
    {
      id: 4,
      title: 'General',
      component: (
        <FRAPGeneral
          robotCaptureProperties={robotCaptureProperties}
          robotId={robotId}
          handleChange={handleChange}
          handleFieldToggle={handleFieldToggle}
          enabledFields={enabledFields}
          lightPath={lightPath}
          frapConfig={frapConfig}
        />
      ),
    },
  ];

  const getTabComponent = () => {
    return FRAPConfigTabs.find((t) => t.id === tab).component;
  };

  return (
    <div
      id="frapcustomcontrols-index-wrapper"
      className="border flex flex-col mt-4 gap-2"
    >
      <span id="frapcustomcontrols-index-title" className="pt-2 px-2">
        FRAP Configuration
      </span>
      <div id="frapcustomcontrols-index-list-wrapper" className="flex flex-row">
        <ul
          id="frapcustomcontrols-index-list"
          className="flex flex-row overflow-hidden !list-none w-full m-0 p-0"
          style={{ borderBottom: '1px solid #dddddd' }}
        >
          {FRAPConfigTabs.map((t) => (
            <li
              id={`frapcustomcontrols-index-tab-${t.id}`}
              key={t.id}
              className={`px-2 py-1 w-48 truncate shrink-0 border cursor-pointer hover:bg-blue-100 ${
                tab === t.id ? 'bg-blue-500/90 text-white hover:bg-blue-500/80' : ''
              }`}
              style={{ borderBottom: '2px solid red !important' }}
              value={t.id}
              title={t.title}
              onClick={() => setTab(t.id)}
            >
              {t.title}
            </li>
          ))}
        </ul>
      </div>
      {getTabComponent()}
    </div>
  );
}

export default FRAPCustomControls;
